module.exports = __webpack_public_path__ + "img/cancel.777f20d7.png";